import App from "../../../vendor_core/core/src/App";
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { ConfigurationTypes } from "../../../vendor_core/core/src/const/ConfigurationTypes";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import ConfigManager from "../../../vendor_core/core/src/managers/ConfigManager";
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from "../../../vendor_core/core/src/model/BuyFeatureModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { DefaultStates } from "../../../vendor_core/core/src/states/DefaultStates";
import StateMachine from "../../../vendor_core/core/src/states/StateMachine";
import { UIButtons } from "../../../vendor_core/core/src/ui/UIButtons";
import { UIComponents } from "../../../vendor_core/core/src/ui/UIComponents";
import { UIModes, UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import { UIUpdateEvent } from "../../../vendor_core/core/src/ui/UIUpdateEvents";
import CurrencyUtils from "../../../vendor_core/core/src/utils/CurrencyUtils";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import Utils from "../../../vendor_core/core/src/utils/Utils";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { MoneyField } from "../../../vendor_core/core/src/views/MoneyField";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import UIDesktop from "../../../vendor_core/src/base/ui/UIDesktop";
import { VendorUIComponents } from "../../../vendor_core/src/base/ui/VendorUIComponents";
import { VendorCommandsEnum } from "../../../vendor_core/src/commands/VendorCommandsEnum";
import VendorModel from '../../../vendor_core/src/model/VendorModel';
import Configs from "../../../vendor_core/src/vendorConfigs/Configs";

export default class VOEUIView extends UIDesktop {

    protected addSpecificFeatureElement() {
        this.scene.buttons.get("buyfeatureSpin").on(PointerEvents.DOWN, () => {
            CommandManager.execute(VendorCommandsEnum.FEATURE_BUTTON_OPTIONS);
            SoundController.playSound(SoundVars.BUTTON_CLICK)
        });
        this.scene.sceneMoneyFields.get("betBuySpin").visible = false;
    }
    public update(event: UIUpdateEvent, props?: any): void {
        if (this.scene) {
            super.update(event, props);
            this.buyFeatureButtonsBehavior();
        }
    }

    private buyFeatureButtonsBehavior() {
        let enable = (StateMachine.state == DefaultStates.Idle);
        let buyFeatureVisible: boolean =
                Configs.buyFeature?.maxFeaturePurchasePrice && 
                ((!SpinModel.inFreegames() && !SpinModel.isInFreespins())
                && !AutoplayModel.isAutoSpinActive());
        if (
            ConfigManager.hasConfig(ConfigurationTypes.GAME)
            && (!Configs.game.clientConfig.disableBuyFeature
            && Configs.buyFeature?.maxFeaturePurchasePrice)
        ) {
            this.scene.buttons.get(UIButtons.FeatureBuy).setEnabled(!BuyFeatureModel.isActivated && enable);
            if (BuyFeatureModel.isActivated || AutoplayModel.isAutoSpinActive()) {
                this.scene.buttons.get(UIButtons.Bet).setEnabled(false);
            }
            let buySpinVisible: boolean = !SpinModel.inFreegames();

            let betVisible: boolean =
                ((!SpinModel.inFreegames() && !SpinModel.isInFreespins()) );
            if (SpinModel.isInFreespins() || AutoplayModel.isAutoSpinActive()) {
                buySpinVisible = false;
            }

            this.scene.buttons.get(UIButtons.FeatureBuy).visible = buyFeatureVisible;

            this.scene.buttons.get(UIButtons.Bet).visible = betVisible;
        }
        if (GameModel.gameConfig.GAME_RULES_ALWAYS_AVAILABLE_JURISDICTIONS
            .find((jurisdiction) => jurisdiction == GameModel.jurisdiction)) {
            this.scene.buttons.get(UIButtons.Settings).setEnabled(true);
        }

        const buyfeatureSpinBtn = this.scene.buttons.get("buyfeatureSpin");
        buyfeatureSpinBtn.visible = buyFeatureVisible;
        buyfeatureSpinBtn.setEnabled(enable);
    }

    protected setBehaviours() {

        let idleButtons = [...this.buttons];
        if (
            GameModel.gameConfig.disableAutoplay &&
            idleButtons.includes(this.scene.buttons.get(UIButtons.AutoPlay))
        ) {
            idleButtons.splice(
                idleButtons.indexOf(this.scene.buttons.get(UIButtons.AutoPlay)),
                1
            );
        }
        let isBuyFeature = false;

        if (
            ConfigManager.hasConfig(ConfigurationTypes.GAME)
            && (!Configs.game.clientConfig.disableBuyFeature
            && Configs.buyFeature?.maxFeaturePurchasePrice)
        ) {
            isBuyFeature = true;
        } else {
            if (idleButtons.includes(this.scene.buttons.get(UIButtons.FeatureBuy))) {
                idleButtons.splice(
                    idleButtons.indexOf(this.scene.buttons.get(UIButtons.FeatureBuy)),
                    1
                );
            }
        }
        let activateTurbo: boolean = Configs.game.clientConfig.quickStop;
        if (!activateTurbo) {
            idleButtons.splice(
                idleButtons.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        }
        this.setBehaviour(UIStates.IDLE, {
            uiToEnable: idleButtons,
            uiToDisable: this.autoplayDisable
                ? [
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ]
                : [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            uiToShow: [
                this.scene,
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                this.scene.buttons.get(UIButtons.Spin),
                this.autoplayDisable ? null : this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.Bet),
                this.scene.groups.get(VendorUIComponents.BottomElementsGroup),
                activateTurbo ? this.scene.buttons.get(UIButtons.Turbo) : null,
                this.scene.sceneTextFields.get("win") as TextField,
                this.scene.sceneMoneyFields.get(UIComponents.WinAlternative) as MoneyField
            ],
            uiToHide: [
                this.autoSpinCounts,
                this.autoplayDisable ? this.scene.buttons.get(UIButtons.AutoPlay) : null,
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
                this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                activateTurbo ? null : this.scene.buttons.get(UIButtons.Turbo),
                isBuyFeature ? null : this.scene.buttons.get(UIButtons.FeatureBuy)
            ],
        });
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet),
                activateTurbo ? this.scene.buttons.get(UIButtons.Turbo) : null,
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
            ],
            uiToEnable: GameModel.canSkipSpin()
            ? [
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.Sound)
            ]
            : [
                this.scene.buttons.get(UIButtons.Sound)
            ],
        });
        this.setBehaviour(UIStates.SPIN_RESULT, {
            uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
            uiToEnable: GameModel.canSkipSpin()
                ? [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Sound)
                ]
                : [
                    this.scene.buttons.get(UIButtons.Sound)
                ],
            uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.SPIN_END, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.STOP_SPIN, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Sound)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.SoundMuted)),
            1
        );
        if (activateTurbo && this.scene.buttons.has(UIButtons.Turbo)) {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        }
        this.setBehaviour(UIStates.AUTO, {
            uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
            uiToShow: [
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ],
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet)
            ],
            uiToDisable: [
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                this.scene.buttons.get(UIButtons.Settings)
            ],
        });

        this.setBehaviour(UIStates.HIDDEN, {
            uiToHide: [this.scene],
        });

        this.setBehaviour(UIStates.PICKSCREEN, {
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet),
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                this.scene.buttons.get(UIButtons.Settings),
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ]
        })
    }

    protected setSettingsBtnInteraction(): void {
        this.assignInterraction(
            [Commands.TOGGLE_SETTINGS],
            this.scene.buttons.get(UIButtons.Settings),
            SoundVars.BUTTON_CLICK,
            true
        );
    }

    protected setFreeSpinsMode() {
        let activateTurbo: boolean = Configs.game.clientConfig.quickStop;
        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Sound)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.SoundMuted)),
            1
        );
        // if it is activated from server, extract it from other buttons and show it constantly
        if (activateTurbo) {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        }
        let isBuyFeature = false;
        if (!Configs.game.clientConfig.disableBuyFeature
             && Configs.buyFeature?.maxFeaturePurchasePrice) {
            isBuyFeature = true;
        } else {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.FeatureBuy)),
                1
            );
        }
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToHide: [
                    ...bonusBts,
                    this.autoSpinCounts,
                    this.scene.groups.get(VendorUIComponents.BottomElementsGroup)
                ],
                uiToEnable: [this.scene.buttons.get(UIButtons.Settings)],
                uiToShow: [this.scene.buttons.get(UIButtons.Turbo)],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Bet),
                    isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                    this.autoSpinCounts,
                    this.scene.sceneTextFields.get("win") as TextField,
                    this.scene.sceneMoneyFields.get(UIComponents.WinAlternative) as MoneyField
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get(UIButtons.AutoPlay)
                ],
                uiToEnable: [GameModel.canSkipSpin(), this.scene.buttons.get(UIButtons.Settings)]
                ? [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Sound)
                ]
                : [
                    this.scene.buttons.get(UIButtons.Sound)
                ],
                uiToShow: [
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    this.scene.buttons.get(UIButtons.Settings)
                ],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.Settings)],
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.PICKSCREEN,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                    isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                    this.scene.buttons.get(UIButtons.Settings),
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            },
            UIModes.FREE_SPINS
        );
    }

    protected setPromotionBehaviours() {
        let isBuyFeature = false;
        if (!Configs.game.clientConfig.disableBuyFeature
            && Configs.buyFeature?.maxFeaturePurchasePrice) {
            isBuyFeature = true;
        }
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [
                    this.scene.buttons.get(UIButtons.Spin),
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Stop),
                    !VendorModel?.freeGames?.autoplay ? this.scene.buttons.get(UIButtons.AutoPlay) : null,
                ],
                uiToShow: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    !VendorModel?.freeGames?.autoplay ? this.scene.buttons.get(UIButtons.AutoPlay) : null,
                    this.autoSpinCounts,
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToDisable: this.buttons,
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
                uiToEnable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.PROMOTION_SPINS
        );
    }
}
